import {
    GETSMSPROVIDERDROPDOWN_SUCCESS,
    GETSMSPROVIDERDROPDOWN_FAILED,
    RESET_GETSMSPROVIDERDROPDOWN,
    LOADING_GETSMSPROVIDERDROPDOWN,
    NETWORK_GETSMSPROVIDERDROPDOWN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETSMSPROVIDERDROPDOWN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETSMSPROVIDERDROPDOWN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETSMSPROVIDERDROPDOWN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_GETSMSPROVIDERDROPDOWN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETSMSPROVIDERDROPDOWN:
            return (state = initialState);
        default:
            return state;
    }
};
